export default __webpack_public_path__ + "static/media/curtain2.3e4aef5d.jpeg";